module.exports = __webpack_public_path__ + "static/media/biometric_design_tab_ok.7235e777.jpg";